import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchTags } from '@/services/aigc';

export const getTags = createAsyncThunk('tag/fetchTags', fetchTags);

export const tagSlice = createSlice({
  name: 'tag',

  initialState: [],

  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getTags.fulfilled, (state, { payload }: any) => {
      if (!payload) {
        return [];
      }
      state = payload;
      return state;
    });
  },
});

export const { } = tagSlice.actions;

export default tagSlice.reducer;
